import React, { FC, ReactElement } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import Button, { ButtonProps } from '@mui/material/Button';
import { clsx } from 'clsx';
import Loader from '../loader';

interface TextButtonProps extends ButtonProps {
    title: string;
    onClick: () => void;
    iconElement?: JSX.Element;
    className?: string;
    customColor?: 'black' | 'lightblue';
    isLoading?: boolean;
}

const TextButton: FC<TextButtonProps> = (props): ReactElement => {
    const { title, onClick, iconElement, className, customColor = 'black', isLoading, ...rest } = props;
    const classes = useStyles();

    return (
        <Button
            onClick={onClick}
            startIcon={iconElement}
            className={clsx(classes.textButtonButton, classes[customColor], className)}
            {...rest}
        >
            {isLoading ? <Loader size={20} /> : title}
        </Button>
    );
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        textButtonButton: {
            fontSize: 14,
            fontWeight: 500,
            paddingLeft: theme.spacing(0.5),
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
            justifyContent: 'flex-start',
            '&:hover': {
                color: theme.palette.colors.text.accent,
                backgroundColor: 'transparent',
            },
        },
        black: {
            color: theme.palette.primary.main,
        },
        lightblue: {
            color: theme.palette.colors.text.accent,
        },
    }),
);

export default TextButton;
